import React, { useState } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import PropTypes from 'prop-types';

import StartNumberSearch from '../event/StartNumberSearch';
import { MAIN_SEARCH_BIB, MAIN_SEARCH_FACE } from '../../../utils/variables';

const ExtendedSearchDualSearchTab = (props) => {
  const { event, startNumber, isAccessGrantedByValidCode, isRedirectedFromStrava } = props;

  const [searchStartNumber, setSearchStartNumber] = useState(props.searchStartnumber);

  const handleInputChange = (target, value) => {
    setSearchStartNumber(value);
  };

  return (
    <div className="dual-carousel">
      <StartNumberSearch
        info={event}
        onInputChange={handleInputChange}
        startNumber={searchStartNumber}
        secondFactor={startNumber}
        searchType={
          event.mainSearch === MAIN_SEARCH_FACE ? MAIN_SEARCH_BIB : MAIN_SEARCH_FACE
        }
        dualSearch={true}
        showSearchHint={false}
        isAccessGrantedByValidCode={isAccessGrantedByValidCode}
        isRedirectedFromStrava={isRedirectedFromStrava}
      />
    </div>
  );
};

ExtendedSearchDualSearchTab.propTypes = {
  event: PropTypes.object,
  startNumber: PropTypes.string,
  searchStartnumber: PropTypes.string,
  isRedirectedFromStrava: PropTypes.bool,
};

export { ExtendedSearchDualSearchTab };

export default createFragmentContainer(ExtendedSearchDualSearchTab, {
  event: graphql`
    fragment ExtendedSearchDualSearchTab_event on Event {
      id
      sgId
      mainSearch
      ...StartNumberSearch_info
    }
  `,
});
